(function ($, Drupal) {

  'use strict';
  function onDocNodeBlogDataLayerReady(context) {
    const $elements = $(once('initializeNodeBlogDataLayerBehavior', 'body', context));
    $elements.each(function() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer = window.dataLayer || [];

      const handleClick = (selector, e) => {
        let contentType = $(selector + ' h2').text();
        let currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, '');
        let featureDetailsText;

        if (selector === '#related-articles') {
          featureDetailsText = $(e.target).closest('.col-12').find('p.h4 a').text();
        } else if (selector === '#latest-articles') {
          featureDetailsText = $(e.target).closest('.col-12').find('p.h4').text();
        }

        let featureDetails = `${currentDate} - ${featureDetailsText}`;

        window.dataLayer.push({
          'event': 'content_module_click',
          'feature_location': 'Below Article Content',
          'content_type': contentType,
          'feature_details': featureDetails
        });
      };

      $('#related-articles a').click((e) => handleClick('#related-articles', e));
      $('#latest-articles a').click((e) => handleClick('#latest-articles', e));
    });
  }
  Drupal.behaviors.initializeNodeBlogDataLayer = {
    attach: function (context) {
      onDocNodeBlogDataLayerReady();
    }
  };

})(jQuery, Drupal);
